<script lang="ts" setup>
import type { FavoriteList } from '~/models/Favorites'
import { useI18n } from 'vue-i18n'
import { PendoFeature } from '~/models/Pendo'
import Button from '~/components/ui/Button.vue'

defineProps<{
  item: FavoriteList
  isLoading: boolean
}>()

const emit = defineEmits<{
  close: []
  delete: [item: FavoriteList]
}>()

const { t } = useI18n()
</script>

<template>
  <div class="space-y-6">
    <p v-text="t('favorite.deleteConfirmationText', { name: item.name })" />
    <div class="flex justify-end gap-2">
      <Button
        variant="outline"
        :disabled="isLoading"
        size="lg"
        @click="emit('close')"
      >
        {{ t('cancel') }}
      </Button>
      <Button
        :data-pendo="PendoFeature.Favorites.DeleteList"
        color="coral"
        size="lg"
        :disabled="isLoading"
        @click="emit('delete', item)"
      >
        {{ t('favorite.deleteList') }}
      </Button>
    </div>
  </div>
</template>
